import { render, staticRenderFns } from "./agreementPrivacy.vue?vue&type=template&id=2ac4d148&scoped=true"
import script from "./agreementPrivacy.vue?vue&type=script&lang=js"
export * from "./agreementPrivacy.vue?vue&type=script&lang=js"
import style0 from "./agreementPrivacy.vue?vue&type=style&index=0&id=2ac4d148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac4d148",
  null
  
)

export default component.exports